module.exports = __webpack_public_path__ + "img/e_1_3_g.96cb53f4.png";